import type { ProblemFilters } from '@/services/types';

export const queryKeys = {
  dashboard: {
    root: ['dashboard'] as const,
    summary: ['dashboard', 'summary'] as const,
    reviewQueue: (limit: number) => ['dashboard', 'review-queue', limit] as const,
    data: (limit: number) => ['dashboard', 'data', limit] as const,
  },
  learning: {
    root: ['learning'] as const,
    path: ['learning', 'path'] as const,
  },
  problems: {
    root: ['problems'] as const,
    list: (filters: ProblemFilters) => ['problems', 'list', filters] as const,
    detail: (id: string) => ['problems', 'detail', id] as const,
  },
  submissions: {
    root: ['submissions'] as const,
    list: ['submissions', 'list'] as const,
    detail: (id: string) => ['submissions', 'detail', id] as const,
    result: (id: string) => ['submissions', 'result', id] as const,
    latestByProblem: (problemId: string) => ['submissions', 'latest-by-problem', problemId] as const,
  },
  profile: {
    me: ['profile', 'me'] as const,
  },
  adminProblems: {
    list: ['admin-problems', 'list'] as const,
  },
  templates: {
    published: (filters: { domain?: string; taskType?: string }) => ['templates', 'published', filters] as const,
    detail: (id: string) => ['templates', 'detail', id] as const,
    adminList: (filters: { domain?: string; taskType?: string; status?: string; keyword?: string }) =>
      ['templates', 'admin-list', filters] as const,
    adminDetail: (id: string) => ['templates', 'admin-detail', id] as const,
  },
  generationJobs: {
    list: ['generation-jobs', 'list'] as const,
    detail: (id: string) => ['generation-jobs', 'detail', id] as const,
    artifacts: (id: string) => ['generation-jobs', 'artifacts', id] as const,
    feedback: (id: string) => ['generation-jobs', 'feedback', id] as const,
  },
  llmProviders: {
    list: ['llm-providers', 'list'] as const,
  },
  judgeAgents: {
    list: ['judge-agents', 'list'] as const,
    availability: ['judge-agents', 'availability'] as const,
  },
  templateOverrides: {
    my: (templateId: string) => ['template-overrides', 'my', templateId] as const,
    list: (filters: { templateId?: string }) => ['template-overrides', 'list', filters] as const,
  },
  adminFeedback: {
    summary: (filters: Record<string, unknown>) => ['admin-feedback', 'summary', filters] as const,
    list: (filters: Record<string, unknown>) => ['admin-feedback', 'list', filters] as const,
  },
};
